import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  ViewChild,
} from '@angular/core';
import { MAT_TOOLTIP_DEFAULT_OPTIONS, MatTooltip } from '@angular/material/tooltip';
import { myCustomTooltipDefaults } from 'src/app/shared/competence-matrix/competence-matrix/competence-matrix.component';

@Component({
  selector: 'app-text-overflow-label',
  templateUrl: './text-overflow-label.component.html',
  styleUrls: ['./text-overflow-label.component.scss'],
  providers: [
    {
      provide: MAT_TOOLTIP_DEFAULT_OPTIONS,
      useValue: {
        ...myCustomTooltipDefaults,
        positionAtOrigin: true,
        showDelay: 100,
        hideDelay: 0,
      },
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TextOverflowLabelComponent {
  @ViewChild('textContainer') textContainer!: ElementRef;
  @ViewChild(MatTooltip) tooltip: MatTooltip;
  // TODO Illia: use in other components
  @Input()
  text = '';

  isOverflowing = false;

  constructor(private cdr: ChangeDetectorRef) {}

  checkOverflow() {
    const element = this.textContainer.nativeElement;
    this.isOverflowing = element.scrollWidth > element.clientWidth;
    this.cdr.detectChanges();
    if (this.isOverflowing) {
      this.tooltip.show();
    }
  }
}
